'use client'

import React, { useState, useEffect } from 'react'
import { useHCRouter } from '@/components/HCNextLink'
import { useLocale } from 'core/components/Locale'
import notification from '@/components/notification'
import { getSearchParams } from 'core/utils'
import styles from './index.module.scss'
import cls from 'classnames'
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice'

type HeaderSearchProps = {
  title?: string
  background?: 'white' | 'gray'
  onSearch?: (query: string) => void
  onInput?: (query: string) => void
  isCenter?: boolean
  isHideButton?: boolean
} & React.HTMLAttributes<HTMLDivElement>

const HeaderSearch: React.FC<HeaderSearchProps> = ({
  title = '',
  background = 'white',
  onSearch,
  onInput,
  isCenter = true,
  className,
  isHideButton,
  ...rest
}) => {
  const t = useLocale()
  const router = useHCRouter()
  const [query, setQuery] = useState<string>('')
  const [isClient, setIsClient] = useState(false)

  const screenType = useResponsiveDevice()

  // 在客戶端首次渲染後設定 isClient 為 true
  useEffect(() => {
    setIsClient(true)

    // 獲取查詢參數
    const queryParam = getSearchParams('query')
    if (queryParam) {
      setQuery(queryParam)
    }
  }, [])

  const handleSearch = () => {
    if (!query.trim()) {
      notification.warning({ message: t('helpIndex_006') })
      return
    }

    if (!onSearch) {
      router.push(`/support/search?query=${query}`)
      return
    }

    onSearch(query)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setQuery(newValue)

    if (!onInput) {
      return
    }

    onInput(newValue)
  }

  // 決定要顯示的標題文字 - 只在客戶端環境使用 screenType
  const titleText = isClient && screenType !== 'phone' ? title : t('hotcoinWeb_v98_EnterYourQuestion')

  // 決定要顯示的預設提示文字
  const placeholderText = isClient && screenType !== 'phone' ? t('support_001') : t('hotcoinWeb_v98_EnterYourQuestion')

  return (
    <div className={cls(styles.searchContent, className, { [styles.gray]: background === 'gray' })} {...rest}>
      <div
        className={cls({
          [styles.searchBox]: true,
          [styles.center]: isCenter,
        })}
      >
        <div className={styles.searchTitle}>{titleText}</div>
        <div className={styles.inputBox}>
          <i className="iconfont iconsousuo1 color-wb7 ex-fontSize16"></i>
          <div className={styles.inputContent}>
            <input
              type="text"
              onKeyUp={(e) => {
                if (e.key === 'Enter') {
                  handleSearch()
                }
              }}
              value={query}
              onChange={handleInputChange}
              placeholder={placeholderText}
            />
          </div>
          {!isHideButton && <button onClick={handleSearch}>{t('area_code_006')}</button>}
        </div>
      </div>
    </div>
  )
}

export default HeaderSearch
